
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { MediaV } from "@/types/media";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import { PageSection } from "@/lib/singularity/page-structure/page-structure";
import { findNode } from "@/lib/tree/tree";
import { documentStore, singularityStore } from "@/store/store";
import lodash from "lodash";
import MediaPreview from "@/components/Reusable/CustomInputs/MediaInput/MediaPreview.vue";
import MediaChooserLayer from "@/components/Reusable/CustomInputs/MediaInput/MediaChooserLayer.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: {
    MediaPreview,
    NiceButton,
    MediaChooserLayer
  }
})
export default class ImageMediaPreview extends Vue {
  @Prop()
  value!: PageSection;

  editBackgroundImage() {
    singularityStore.setImageEditorPanelState({
      elementId: this.value.nodeId,
      controlPath: "design.background.image",
      initialStep: "main"
    });
    singularityStore.setSingularityLeftPanel("image_editor");
  }

  get internalValue() {
    const section = findNode(documentStore.document.tree, this.value.nodeId);
    if (!section) return false;

    const maybeImage = lodash.get(
      section.data.properties,
      "design.background.image"
    );

    return pipe(
      maybeImage,
      MediaV.decode,
      fold(
        error => {
          console.debug("Media decoder failed", error);
          return undefined;
        },
        image => image
      )
    );
  }
}
